<template>
    <Button :class="classes" :disabled="isDisabled" :loading="isLoading" :type="buttonType" @click="emitClick">
        <slot />
        <Icon class="dropdown-button__arrow" type="ios-arrow-down" />
    </Button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        buttonType: {
            type: String,
            default: "default"
        },

        isActive: {
            type: Boolean
        },
        isDisabled: {
            type: Boolean
        },
        isLoading: {
            type: Boolean
        }
    },

    emits: ["click"],

    computed: {
        classes() {
            const classes = ["dropdown-button"];
            if (this.isActive) {
                classes.push("dropdown-button--active");
            }
            return classes;
        }
    },
    methods: {
        emitClick(event: MouseEvent) {
            /*
                To avoid having to do `@click.native` all the time we capture
                the click event and emit it manually.
            */
            this.$emit("click", event);
        }
    }
});
</script>
